import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { CompraVendaComponent } from 'app/views/relatorio/compra-venda/compra-venda.component';
import { JwtAuthService } from './auth/jwt-auth.service';

@Injectable({
  providedIn: 'root'
})
export class ComprasVendasService {

  readonly url = `${environment.apiURL}/relatorio/compra_venda`;
  

  // constructor(private http: HttpClient) { }
  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) {  }


  saveOrUpdate(relatorio: CompraVendaComponent): Observable<CompraVendaComponent> {
    return this.http.put<CompraVendaComponent>(`${this.url}`, relatorio);
  }

  getItem(id: number ): Observable<CompraVendaComponent> {
    return this.http.get<CompraVendaComponent>(`${this.url}/${id}`);
  }

  getItemPage(page?: number, size?: number,
    order?: string, direction?: string): Observable<PageResult<CompraVendaComponent>> {
    return this.http.get<PageResult<CompraVendaComponent>>(`${this.url}/page/get/?page=${page}&size=`
     + `${size}&order=${order}&direction=${direction}`);
  }

  getItemPageSearch(page?: number, size?: number,  search?: string,
    order?: string, direction?: string): Observable<PageResult<CompraVendaComponent>> {
    return this.http.get<PageResult<CompraVendaComponent>>(`${this.url}/page/get/?page=${page}&size=` +
    `${size}&search=${search}&order=${order}&direction=${direction}`);
  }

  printForm(controle: number , formId: number, onlyPrint = false): Observable<any> {
    return this.http.get(`${this.url}/print/${controle}/${formId}/${onlyPrint}`, {responseType: 'arraybuffer'});
  }

  pdfCarta(id: number): Observable<any> {
    return this.http.get(`${this.jwtAuthService.apiUrl + this.url}/carta/correcao/print/${id}`, {responseType: 'arraybuffer'})
  }
}
